import { createTheme } from "@mui/material/styles";

const headerTheme = createTheme({
  palette: {
    neutral: {
      main: "#001E3C",
      contrastText: "#fff"
    }
  }
});

export { headerTheme };
